module.exports = __webpack_public_path__ + "media/assets_v3/images/user-panel/telegram_qr-6adde53819e12483d5279e8755fe8ca9.png";